import { useAsyncCallback } from '@wix/cli-ui-kit';
import { CliErrorCode, CliError } from '@wix/cli-error';
import { loadFiles, loadDeployableFiles } from '@wix/cli-deployable-files';
import { readBuildMetadata } from '../../../files/build-metadata.js';
import { useProjectModel } from '../../../model.js';

export function useLoadBuildFiles() {
  const {
    model: { projectFolder, config },
  } = useProjectModel();

  return useAsyncCallback(async () => {
    const buildMetadata = await readBuildMetadata(projectFolder, config);

    // Once metadata is read from config, load the files specified by site.outputDirectory.
    // Because this can point to the root project folder, we must apply additional filtering
    // to skip lock, log, and config files, avoiding the accidental upload of sensitive information.
    const load =
      buildMetadata.metaDataSource === 'WIX_CONFIG'
        ? loadDeployableFiles
        : loadFiles;

    const client = (
      buildMetadata.clientDir ? await load(buildMetadata.clientDir) : []
    ).filter(({ path }) => {
      if (path === buildMetadata.appManifestPath) {
        return false;
      }
      // cloudflare adapter for astro project is storing server files inside client directory
      // so we must ensure that server files are not uploaded as static files.
      if (buildMetadata.serverDir && path.startsWith(buildMetadata.serverDir)) {
        return false;
      }
      return true;
    });

    const server = (
      buildMetadata.serverDir ? await load(buildMetadata.serverDir) : []
    ).filter(({ path }) => {
      if (path === buildMetadata.appManifestPath) {
        return false;
      }
      return true;
    });

    if (client.length + server.length === 0) {
      throw new CliError({
        code: CliErrorCode.BuildOutputMissing({
          reason: "Could't find neither client nor server build output files.",
        }),
        cause: null,
      });
    }

    return { client, server };
  });
}
